import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';
import { subscribeConfiguration } from '../../common/saveconfiguration/sagas';

const pre = 'IMPACTANALYSIS/IMPACTDETAILED/';

export const CSV_EXPORT_EMPTY = `${pre}CSV_EXPORT_EMPTY`;
export const SET_ALL_EXPANDED = `${pre}SET_ALL_EXPANDED`;
export const SET_IMPACT_DETAILED_COLUMNS = `${pre}SET_IMPACT_DETAILED_COLUMNS`;
export const SET_IMPACT_DETAILED_ROWS = `${pre}SET_IMPACT_DETAILED_ROWS`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const TOGGLE_ROW_EXPANDED = `${pre}TOGGLE_ROW_EXPANDED`;
export const IMPACT_DETAILED_LOADED = `${pre}IMPACT_DETAILED_LOADED`;
export const SET_IMPACT_DETAILED_DATA_LOADED = `${pre}SET_IMPACT_DETAILED_DATA_LOADED`;
export const SET_DEFAULT_CONFIG = `${pre}SET_DEFAULT_CONFIG`;

subscribe(CSV_EXPORT_EMPTY, 'Failed to export as CSV - no data', notificationError);
subscribeConfiguration(SET_IMPACT_DETAILED_COLUMNS, 'ImpactAnalysis');

export const setDefaultConfig = columns => ({
    type: SET_DEFAULT_CONFIG,
    columns
});

export const setImpactDetailedDataLoaded = loaded => ({
    type: SET_IMPACT_DETAILED_DATA_LOADED,
    loaded
});

export const impactDetailedLoaded = () => ({
    type: IMPACT_DETAILED_LOADED
});

export const csvExportEmpty = error => ({
    type: CSV_EXPORT_EMPTY,
    error
});

export const setAllExpanded = data => ({
    type: SET_ALL_EXPANDED,
    data
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const setImpactDetailedColumns = data => ({
    type: SET_IMPACT_DETAILED_COLUMNS,
    data
});

export const setImpactDetailedRows = data => ({
    type: SET_IMPACT_DETAILED_ROWS,
    data
});

export const toggleRowExpanded = data => ({
    type: TOGGLE_ROW_EXPANDED,
    data
});
